import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Panel } from 'react-bootstrap';
import { fetchFinanciamiento, fetchFichasVenta, fetchCapacitacion, fetchInmatriculacion, fetchGestionCosto } from '../../../actions';
import formatMoney from '../../../utils/formatMoney';

class AccesosDirecto extends Component {
  static hideMessage() {
    document.getElementById('alertFinanciamiento').style.display = 'flex';
    document.getElementById('alertCapacitacion').style.display = 'flex';
    setTimeout(() => {
      if (document.getElementById('alertFinanciamiento')) {
        document.getElementById('alertFinanciamiento').style.display = 'none';
      }
      if (document.getElementById('alertCapacitacion')) {
        document.getElementById('alertCapacitacion').style.display = 'none';
      }
    }, 3000);
  }

  constructor(props) {
    super(props);
    this.state = {
      mostrarPanel: false,
      activeIndex: 0,
      iconAlert: '',
      mensajeAlert: '',
      listaFinanciamiento: [],
      listaCapacitacion: [],
      listaInmatriCab: [],
      listaInmatriDet: [],
      listaGestionCab: [],
      listaGestionDet: [],
      mostrarFila: '',
      /*Inicio Req 92293 ebarboza 09 08 2021 */
      codTipoMonedaProforma:props.codTipoMonedaProforma,
      /*Fin Req 92293 ebarboza 09 08 2021 */
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClickfinaciamiento = this.handleClickfinaciamiento.bind(this);
    this.handleClickCapacitacion = this.handleClickCapacitacion.bind(this);
    this.handleClickGestionCosto = this.handleClickGestionCosto.bind(this);
  }

  componentDidMount() {
    console.log(this.props.fdvID);
  }

  handleClick(e) {
    const index = e.currentTarget.value;
    this.setState({ activeIndex: index });
  }

  togglePanel = () => this.setState({ mostrarPanel: !this.state.mostrarPanel })
  togglePanel2 = (index) => {
    console.log(index);
    if (index === this.state.mostrarFila) {
      this.setState({ mostrarFila: '' });
    } else {
      this.setState({ mostrarFila: index });
    }
  }

  handleClickfinaciamiento(e) {
    console.log(this.props.fdvID);
    let hasPermission = false;
    let promise = new Promise((resolve, reject) => {
      hasPermission = this.props.handlePermissions(e);
      resolve();
    });
    promise.then(result => {
      if(hasPermission) {
        this.props.fetchFinanciamiento(this.props.fdvID)
          .then((result) => {
            // console.log(result);
            if (result.payload.data.estadoTrama === '1') { // ok
              this.setState({ listaFinanciamiento: result.payload.data.financiamiento });
            } else if (result.payload.data.estadoTrama === '0') {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
              AccesosDirecto.hideMessage();
            } else if (result.payload.data.estadoTrama === '-1') {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
              AccesosDirecto.hideMessage();
            } else {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
              AccesosDirecto.hideMessage();
            }
          });
      }
    });
    const index = e.currentTarget.value;
    this.setState({ activeIndex: index });
  }

  handleClickCapacitacion(e) {
    e.persist();
    let hasPermission = false;
    let promise = new Promise((resolve, reject) => {
      hasPermission = this.props.handlePermissions(e);
      resolve();
    });
    promise.then(result => {
      if(hasPermission) {
        this.props.fetchCapacitacion(this.props.fdvID)
          .then((result) => {
            console.log(result);
            if (result.payload.data.estadoTrama === '1') { // ok
              this.setState({ listaCapacitacion: result.payload.data.capacitaciones });
            } else if (result.payload.data.estadoTrama === '0') {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
              AccesosDirecto.hideMessage();
            } else if (result.payload.data.estadoTrama === '-1') {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
              AccesosDirecto.hideMessage();
            } else {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
              AccesosDirecto.hideMessage();
            }
          });
      }
    });
    const index = e.currentTarget.value;
    this.setState({ activeIndex: index });
  }

  handleClickGestionCosto(e) {
    console.log(this.props.fdvID);
    let hasPermission = false;
    let promise = new Promise((resolve, reject) => {
      hasPermission = this.props.handlePermissions(e);
      resolve();
    });
    promise.then(result => {
      if(hasPermission) {
        this.props.fetchGestionCosto(this.props.fdvID,'A')
          .then((result) => {
            console.log('result',result);
            if (result.payload.data.estadoTrama === '1') { // ok
              this.setState({ listaGestionCab: result.payload.data.gestionCostoCab });
              this.setState({ listaGestionDet: result.payload.data.gestionCostoDet });
            } else if (result.payload.data.estadoTrama === '0') {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: result.payload.data.mensaje });
              AccesosDirecto.hideMessage();
            } else if (result.payload.data.estadoTrama === '-1') {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!` });
              AccesosDirecto.hideMessage();
            } else {
              this.setState({ muestraLoad: 'none', iconAlert: 'ion-close-circled', colorBackground: '#F56669', mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!` });
              AccesosDirecto.hideMessage();
            }
          });
      }
    });
    const index = e.currentTarget.value;
    this.setState({ activeIndex: index });    
  }

  render() {
    const { activeIndex } = this.state;
    return (
      <section className='fdv-section' id='accesosDirectos'>
        <div className='row'>
          <div className='col-md-2'>
            <ul className='sidebar' role='tablist'>
              <li className={activeIndex === 0 ? 'active' : ''} value='0' onClick={this.handleClickfinaciamiento} data-permisos='ind_accdir_finaciamiento'>
                <a className='sidebar-link' >Financiamiento</a>
              </li>
              <li className={activeIndex === 1 ? 'active' : ''} value='1' onClick={this.handleClickGestionCosto} data-permisos='ind_accdir_gestion_costos'>
                <a className='sidebar-link'  >Gestión de costos</a>
              </li>
              <li className={activeIndex === 2 ? 'active' : ''} value='2' onClick={this.handleClickCapacitacion} data-permisos='ind_accdir_capacitacion'>
                <a className='sidebar-link' >Capacitación</a>
              </li>
            </ul>
          </div>
          <div className='col-md-10'>
            <div className='tab-content'>
              <section className={`fdv-section tab-pane ${activeIndex === 0 ? 'active' : ''}`} id='accesosFinanciamiento'>
                <header className='fdv-section-head'>
                  <h5 className='fdv-section-title'>Solicitud de crédito</h5>
                </header>
                <div className='tableWrapper hidden-xs'>
                  <table className='table table-hover'>
                    <thead className='table-head'>
                      <tr>
                        <th>Nº Solic.</th>
                        <th>Estado</th>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th/>
                      </tr>
                    </thead>
                    {this.state.listaFinanciamiento.map((listaFinanciamiento, index) => (
                      <tbody>
                        <tr className='as' data-target='#tp1' onClick={() => this.togglePanel2(index)}>
                          <td>
                            {listaFinanciamiento.codCredito}
                          </td>
                          <td>
                            <span className='pill pill-yellow'>
                              {listaFinanciamiento.desEstadoCred}
                            </span>
                          </td>
                          <td>
                            {listaFinanciamiento.fecSoliCred}
                          </td>
                          <td>
                            {listaFinanciamiento.desTipoCred}
                          </td>
                          <td>
                            {true ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />}
                          </td>
                        </tr>
                        <tr className='table-extra'>
                          <td colSpan='7'>
                            <Panel collapsible expanded={this.state.mostrarFila === index} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }} >
                              <div className='collapse in' id='tp1' aria-expanded="true">
                                <div className='table-extra-wrap'>
                                  <div className='row'>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>N° de Operación</p>
                                      <p>{listaFinanciamiento.codOper}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Estado de Operacion</p>
                                      <p>{listaFinanciamiento.desEstadoOpe}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Fecha de giro</p>
                                      <p>{listaFinanciamiento.fechaGiro}</p>
                                    </div>
                                  </div>
                                  <div className='row'>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Total a Financiar</p>
                                      <p>{this.state.codTipoMonedaProforma === "DOL"?'US$ ':'S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(listaFinanciamiento.valMontoCred)}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>TEA</p>
                                      <p>{listaFinanciamiento.valTea}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>N° Letras</p>
                                      <p>{listaFinanciamiento.numLetras}</p>
                                    </div>
                                  </div>

                                  <div className='row'>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Primer vencimiento</p>
                                      <p>{listaFinanciamiento.primerVenc}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Max vencimiento</p>
                                      <p>{listaFinanciamiento.maxVenc}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Autorizador</p>
                                      <p>{listaFinanciamiento.autoriz}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>F° Autorización</p>
                                      <p>{listaFinanciamiento.fecAutoriz}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Panel>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </section>
              <section className={`fdv-section tab-pane ${activeIndex === 1 ? 'active' : ''}`} id='accesosGestion'>
                <header className='fdv-section-head'>
                  <h5 className='fdv-section-title'>Gestión de costos</h5>
                </header>
                <div className='tableWrapper table-fitIn-accordion hidden-xs'>
                  <table className='table table-hover'>
                    <thead className='table-head'>
                      <tr>
                        <th>Nº Pedido</th>
                        <th>Costo Plan.</th>
                        <th>Valor lista</th>
                        <th>Valor venta</th>
                        <th>Cant</th>
                        <th>Rentabilidad</th>
                        <th/>
                      </tr>
                    </thead>
                    {this.state.listaGestionCab.map((listaGestionCab, index) => (
                      <tbody>
                        <tr className='as' data-target='#pkj1' onClick={() => this.togglePanel2(index)}>
                          <td> {listaGestionCab.numPedVeh} </td>
                          <td>{this.state.codTipoMonedaProforma === "DOL"?'US$ ':'S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(listaGestionCab.costoPlanif)} </td>
                          <td>{this.state.codTipoMonedaProforma === "DOL"?'US$ ':'S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(listaGestionCab.valorLista)} </td>
                          <td>{this.state.codTipoMonedaProforma === "DOL"?'US$ ':'S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(listaGestionCab.valorVenta)} </td>
                          <td> {listaGestionCab.cant} </td>
                          <td>{this.state.codTipoMonedaProforma === "DOL"?'US$ ':'S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(listaGestionCab.rentab)} </td>
                          <td> {true ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />} </td>
                        </tr>

                        <tr className='table-extra'>
                          <td colSpan='7'>
                            <Panel collapsible expanded={this.state.mostrarFila === index} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }} >
                              <div className='collapse in' id='pkj1'>
                                <div className='table-extra-wrap'>

                                  <div className='tableWrapper'>
                                    <table className="table table-hover">
                                      <thead className="table-head">
                                        <tr>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>

                                        {this.state.listaGestionDet.filter(value => value.numPedidoVeh === listaGestionCab.numPedVeh)
                                          .map(lista => (
                                            <tr >

                                              <td style={{ fontWeight: 'bold' }}> {lista.nombre} </td>
                                              <td style={{ fontWeight: 'bold' }}>{this.state.codTipoMonedaProforma === "DOL"?' US$ ':' S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(lista.costoPlanif)} </td>
                                              <td style={{ fontWeight: 'bold' }}>{this.state.codTipoMonedaProforma === "DOL"?' US$ ':' S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(lista.valorLista)} </td>
                                              <td style={{ fontWeight: 'bold' }}>{this.state.codTipoMonedaProforma === "DOL"?' US$ ':' S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(lista.valorVenta)} </td>
                                              <td style={{ fontWeight: 'bold' }}> {lista.cant} </td>
                                              <td style={{ fontWeight: 'bold' }}>{this.state.codTipoMonedaProforma === "DOL"?' US$ ':' S/ '/*Req 92293 ebarboza 09 08 2021*/}{formatMoney(lista.rentab)} </td>
                                              <td></td>
                                            </tr>
                                          ))}

                                      </tbody>
                                    </table>
                                  </div>

                                </div>
                              </div>
                            </Panel>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </section>
              <section className={`fdv-section tab-pane ${activeIndex === 2 ? 'active' : ''}`} id='accesosCapacitaciones'>
                <header className='fdv-section-head'>
                  <h5 className='fdv-section-title'>Capacitaciones</h5>
                </header>
                <div className='tableWrapper hidden-xs'>
                  <table className='table table-hover'>
                    <thead className='table-head'>
                      <tr>
                        <th>Nº Capacit.</th>
                        <th>Estado</th>
                        <th>Fecha Inicio</th>
                        <th>Fecha Fin</th>
                        <th>Lugar</th>
                      </tr>
                    </thead>
                    {this.state.listaCapacitacion.map((listaCapacitacion, index) => (
                      <tbody>
                        <tr className='as' data-target='#htc12' onClick={() => this.togglePanel2(index)}>
                          <td>
                            {listaCapacitacion.numCapa}
                          </td>
                          <td><span className='pill pill-green'>
                            {listaCapacitacion.estado}
                          </span></td>
                          <td>
                            {listaCapacitacion.fechaIni}
                          </td>
                          <td>
                            {listaCapacitacion.fechaFin}
                          </td>
                          <td>
                            {listaCapacitacion.lugar}
                          </td>
                          <td>
                            {true ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />}
                          </td>
                        </tr>
                        <tr className='table-extra'>
                          <td colSpan='7'>
                            <Panel collapsible expanded={this.state.mostrarFila === index} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }} >
                              <div className='collapse in' id='htc12'>
                                <div className='table-extra-wrap'>
                                  <div className='row'>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Nombre</p>
                                      <p>{listaCapacitacion.desCapa}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Tipo</p>
                                      <p>{listaCapacitacion.tipo}</p>
                                    </div>
                                    <div className='col-md-3'>
                                      <p className='labelInfo'>Instructor</p>
                                      <p>{listaCapacitacion.instructor}</p>
                                    </div>
                                  </div>

                                  <div className='row'>
                                    <div className='col-md-12'>
                                      <p className='labelInfo'>Observaciones</p>
                                      <p>{listaCapacitacion.observ}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Panel>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </section>
            </div>
          </div>
          <div className='alert alert-warning' role='alert' id='alertFinanciamiento' style={{ display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground }}>
            <i className={this.state.iconAlert} />
            <p>{this.state.mensajeAlert}</p>
          </div>
          <div className='alert alert-warning' role='alert' id='alertCapacitacion' style={{ display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground }}>
            <i className={this.state.iconAlert} />
            <p>{this.state.mensajeAlert}</p>
          </div>
        </div>
      </section>
    );
  }

}


function mapStateToProps(state) {
  return {
    financiamiento: state.financiamiento,
    capacitacion: state.capacitacion,
    inmatriculacion: state.inmatriculacion,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchFichasVenta, fetchFinanciamiento, fetchCapacitacion, fetchInmatriculacion, fetchGestionCosto,
  })(AccesosDirecto));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/AccesosDirecto.js